import { ProdutoSegmento } from './produto-segmento.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class ProdutoSegmentoService {

    constructor(private http: Http) {
    }

    getProdutoSegmentos(): Observable<ProdutoSegmento[]> {
        return this.http.get(`${NTECH_API}/produto-segmento`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/produto-segmento/produto-segmento.service.ts